

/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState, Fragment } from 'react';
import MainHeader from "../../../../Shared/components/Header";
import customStyles from "../../../../../assets/styles/customStyles";
import { CustomForm } from './CustomForm';
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import crudActions from "../../../../CRUD/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { toast } from 'react-toastify';
import { checkCRUDViewPermission } from "../../../../../helpers/utilities";
import PurchaseIcon from "../../../../../assets/images/icon_menus/PurchaseIcon.json";
import { GoodsReceiptForm } from './GoodsReceiptForm';
import { InvoiceForm } from './InvoiceForm';

const PurchaseOrderCreate = (props) => {
    const { readDetails, readError } = useSelector(state => state.crudReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const formRef = useRef('');
    const { history } = props;
    const dispatch = useDispatch();
    let { orderId } = useParams();
    const [view, setView] = useState(false);
    const { type } = useParams();
    const prevReadDetails = usePrevious(readDetails);
    const [showDetails, setShowDetails] = useState(true);


    useEffect(() => {
        if (!orderId && (type === 'view' || type === 'edit')) {
            history.push('/purchase/purchase-management/purchase-order');
            return true;
        }
        if (roleManagement !== '' && checkCRUDViewPermission('Purchase Order', type, history, 'Purchase')) {
            loadTask();
        }
        if (type === 'view') {
            setView(true);
        } else {
            setView(false);
        }

    }, [orderId, type, roleManagement]);


    const loadTask = () => {
        if (orderId) {
            dispatch({ type: crudActions.READ_DETAILS_START, id: orderId, url: "v1/sales-order/purchase-orders" });
        }
    }


    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            setShowDetails(false);
            if (type === 'view' || readDetails?.OrderStatus === 'DELIVERED' || readDetails?.OrderStatus === 'INVOICED' || readDetails?.OrderStatus === 'ORDERED' ||
                (readDetails?.inAppTransition && readDetails?.OrderStatus === 'SUBMITTED')
                || readDetails?.OrderStatus === 'ACCEPTED' || readDetails?.OrderStatus === 'CANCELLED') {
                setView(true);
            } else {
                setView(false);
            }
            formRef.current.onEdit(readDetails);
        } else if (readError) {
            if (readError.error.statusCode) {
                toast.error('Purchase Order ID is invalid');
                history.push('/purchase/purchase-management/purchase-order');
            }
        }
    }, [readDetails, readError]);

    const classes = customStyles();
    return (
        <Fragment>
            <MainHeader {...props} cls={'newImg'} img={PurchaseIcon} title={'Purchase'} links={[{ 'label': 'Purchase', 'link': '/purchase' },
            { 'label': 'Order', 'link': '' }]}
                handleCloseClick={() => type === 'create' ? history.go(-1) : history.push('/purchase/purchase-management/purchase-order')}
            />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky,
                { [classes.scrollBorder]: type === 'create' ? true : !showDetails })}>
                <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                    {
                        type === 'goods-receipt' ? <GoodsReceiptForm
                            ref={formRef}
                            showDetails={showDetails}
                            view={view}
                            orderId={orderId}
                            type={type}
                            roleManagement={roleManagement}
                            loadTask={() => loadTask()}
                            classes={classes}
                            dispatch={dispatch}
                            clsx={clsx}
                            {...props}
                        /> : type === 'invoice' ? <InvoiceForm
                            ref={formRef}
                            showDetails={showDetails}
                            view={view}
                            orderId={orderId}
                            type={type}
                            roleManagement={roleManagement}
                            loadTask={() => loadTask()}
                            classes={classes}
                            dispatch={dispatch}
                            clsx={clsx}
                            {...props}
                        /> : <CustomForm
                            ref={formRef}
                            showDetails={type === 'create' ? false : showDetails}
                            view={view}
                            orderId={orderId}
                            type={type}
                            roleManagement={roleManagement}
                            loadTask={() => loadTask()}
                            classes={classes}
                            dispatch={dispatch}
                            clsx={clsx}
                            {...props}
                        />
                    }
                </div>
            </div>
        </Fragment>
    )
}

export default PurchaseOrderCreate